"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useDeviceCodeLogin = exports.DEVICE_CODE_GRANT_TYPE = void 0;
const react_1 = require("react");
const defaultOptions = {
    scopes: 'openid profile email offline_access',
};
exports.DEVICE_CODE_GRANT_TYPE = 'urn:ietf:params:oauth:grant-type:device_code';
const useDeviceCodeLogin = (options) => {
    const mergedOptions = { ...defaultOptions, ...options };
    const [deviceCode, setDeviceCode] = (0, react_1.useState)();
    const [userCode, setUserCode] = (0, react_1.useState)();
    const [verificationUri, setVerificationUri] = (0, react_1.useState)();
    const [tokenPayload, setTokenPayload] = (0, react_1.useState)();
    const [error, setError] = (0, react_1.useState)();
    const delayRef = (0, react_1.useRef)();
    const expiresInRef = (0, react_1.useRef)();
    const intervalRef = (0, react_1.useRef)();
    const timeoutRef = (0, react_1.useRef)();
    const getDeviceCode = (0, react_1.useCallback)(async () => {
        const details = {
            client_id: mergedOptions.clientId,
            audience: mergedOptions.audience,
            scope: mergedOptions.scopes,
        };
        const formBody = [];
        for (const property in details) {
            const encodedKey = encodeURIComponent(property);
            const encodedValue = encodeURIComponent(details[property]);
            formBody.push(encodedKey + '=' + encodedValue);
        }
        const form = formBody.join('&');
        try {
            const response = await fetch(options.getDeviceCodeUrl, {
                method: 'POST',
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/x-www-form-urlencoded',
                },
                body: form,
            });
            if (response.ok) {
                const { device_code, verification_uri_complete, interval, expires_in, user_code, } = await response.json();
                delayRef.current = interval * 1000;
                expiresInRef.current = expires_in * 1000;
                setDeviceCode(device_code);
                setVerificationUri(verification_uri_complete);
                setUserCode(user_code);
            }
        }
        catch (error) {
            setError(error);
        }
    }, [
        mergedOptions.audience,
        mergedOptions.clientId,
        mergedOptions.scopes,
        options.getDeviceCodeUrl,
    ]);
    const getAccessToken = (0, react_1.useCallback)(async () => {
        const details = {
            client_id: options.clientId,
            device_code: deviceCode !== null && deviceCode !== void 0 ? deviceCode : '',
            grant_type: exports.DEVICE_CODE_GRANT_TYPE,
        };
        const formBody = [];
        for (const property in details) {
            const encodedKey = encodeURIComponent(property);
            const encodedValue = encodeURIComponent(details[property]);
            formBody.push(encodedKey + '=' + encodedValue);
        }
        const form = formBody.join('&');
        try {
            const response = await fetch(options.getTokenUrl, {
                method: 'POST',
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/x-www-form-urlencoded',
                },
                body: form,
            });
            if (response.ok) {
                const { access_token, id_token, refresh_token, expires_in } = await response.json();
                setTokenPayload({
                    accessToken: access_token,
                    idToken: id_token,
                    refreshToken: refresh_token,
                    expiresIn: expires_in,
                });
                clearInterval(intervalRef.current);
            }
        }
        catch (error) {
            setError(error);
        }
    }, [options.getTokenUrl, options.clientId, deviceCode]);
    (0, react_1.useEffect)(() => {
        if (deviceCode && options.clientId) {
            intervalRef.current = setInterval(getAccessToken, delayRef.current);
            timeoutRef.current = setTimeout(() => clearInterval(intervalRef.current), expiresInRef.current);
        }
        return () => {
            clearInterval(intervalRef.current);
            clearTimeout(timeoutRef.current);
        };
    }, [deviceCode, getAccessToken, options.clientId]);
    return {
        tokenPayload,
        verificationUri,
        error,
        getDeviceCode,
        userCode,
        expiresInRef,
    };
};
exports.useDeviceCodeLogin = useDeviceCodeLogin;
//# sourceMappingURL=useDeviceCodeLogin.js.map